// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorkerRegistration from './serviceWorkerRegistration'; // ✅ NUEVO

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// ✅ NUEVO: Registrar PWA Service Worker
serviceWorkerRegistration.register({
  onSuccess: (registration) => {
    console.log('✅ PWA lista para uso offline');
    console.log('📦 Service Worker registrado:', registration);
  },
  onUpdate: (registration) => {
    console.log('🔄 Nueva versión disponible - Recarga para actualizar');
    registration.waiting?.postMessage({ type: 'SKIP_WAITING' });
  }
});
